/**
 * @generated SignedSource<<43373a91050e06cbfb3d05bed0215c6d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type searchResult_AtlassianSearchPage$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"searchResultRenderer_AtlassianSearchPage">;
  readonly " $fragmentType": "searchResult_AtlassianSearchPage";
};
export type searchResult_AtlassianSearchPage$key = {
  readonly " $data"?: searchResult_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchResult_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeAssets"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeAssigneeField"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeIconUrl"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeIssueTypeField"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeJiraLiteModeFields"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeNavBoostScore"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includePassionfruitAsk"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includePositions"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeThirdPartyId"
    }
  ],
  "kind": "Fragment",
  "name": "searchResult_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "includeAssets",
          "variableName": "includeAssets"
        },
        {
          "kind": "Variable",
          "name": "includeAssigneeField",
          "variableName": "includeAssigneeField"
        },
        {
          "kind": "Variable",
          "name": "includeIconUrl",
          "variableName": "includeIconUrl"
        },
        {
          "kind": "Variable",
          "name": "includeIssueTypeField",
          "variableName": "includeIssueTypeField"
        },
        {
          "kind": "Variable",
          "name": "includeJiraLiteModeFields",
          "variableName": "includeJiraLiteModeFields"
        },
        {
          "kind": "Variable",
          "name": "includeNavBoostScore",
          "variableName": "includeNavBoostScore"
        },
        {
          "kind": "Variable",
          "name": "includePassionfruitAsk",
          "variableName": "includePassionfruitAsk"
        },
        {
          "kind": "Variable",
          "name": "includePositions",
          "variableName": "includePositions"
        },
        {
          "kind": "Variable",
          "name": "includeThirdPartyId",
          "variableName": "includeThirdPartyId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "searchResultRenderer_AtlassianSearchPage"
    }
  ],
  "type": "SearchResult",
  "abstractKey": "__isSearchResult"
};

(node as any).hash = "fea3513b1a274e2dcde77b066eed3dae";

export default node;
